
import React from 'react';
import { LoadingSpinner } from '@/components/ui';

interface LoadingMeetingProps {
  message?: string;
}

export const LoadingMeeting: React.FC<LoadingMeetingProps> = ({
  message = 'Connecting to meeting...',
}) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-600">{message}</p>
      </div>
    </div>
  );
};
